import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import ReactTilt from 'react-universal-tilt';
import { Popover, Menu, MenuItem, Button, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import colors from 'utils/colors';

const NavigationBody = ({
  logout,
  appUser,
  history,
  match,
  clearIntervalOnLogout,
}) => {
  const doLogout = () => {
    history.push(match.url);
    clearIntervalOnLogout();
    logout();
  };

  return (
    <Container>
      <ColoredLine />
      <StyledNavbar>
        <ReactTilt
          options={{
            max: 3,
            scale: 1.05,
          }}
        >
          <NavLink to="/">
            <Logo
              src={require('images/logo.png')}
              alt={process.env.REACT_APP_LOGO_ALT_TEXT || 'Logo'}
            />
          </NavLink>
        </ReactTilt>
        <Popover
          content={
            <Menu>
              <MenuItem text="Logout" onClick={doLogout} />
            </Menu>
          }
          position={Position.BOTTOM}
          interactionKind="hover"
        >
          <Button minimal={true} rightIcon={IconNames.CHEVRON_DOWN}>
            <UserIcon>
              <span>
                {appUser.firstName && appUser.firstName.charAt(0)}
                {appUser.lastName && appUser.lastName.charAt(0)}
              </span>
            </UserIcon>
          </Button>
        </Popover>
      </StyledNavbar>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1;
  -webkit-box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0),
    0 1px 1px rgba(16, 22, 26, 0.2);
  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0),
    0 1px 1px rgba(16, 22, 26, 0.2);
  background: #fff;
`;
const ColoredLine = styled.div`
  height: 8px;
  background: ${colors.brandingAccent};
`;

const UserIcon = styled.div`
  border-radius: 50px;
  background: ${colors.brandingPrimary};
  text-transform: uppercase;
  font-size: 1.2rem;
  height: 3rem;
  width: 3rem;
  margin: 0 1rem;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  width: 15%;
  min-width: 250px;
  height: auto;
  background-repeat: no-repeat;
  background-size: contain;
`;

const StyledNavbar = styled.nav`
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
`;

export default withRouter(NavigationBody);
